export  enum TypeSituacao {
    VIGENTE = "Vigente",    
    ALTERADA = "Alterada",
    REVOGADA = "Revogada",
}
export default TypeSituacao;

